import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Separate Firebase project dedicated to storing Orders
const firebaseOrdersConfig = {
  apiKey: "AIzaSyCOox45zlNrgvuSaWWjwYRfOf78dw7R3OU",
  authDomain: "whubclasses.firebaseapp.com",
  projectId: "whubclasses",
  storageBucket: "whubclasses.firebasestorage.app",
  messagingSenderId: "13701013703",
  appId: "1:13701013703:web:5e372c7df8ab8e17acdee2",
  measurementId: "G-3WN7KZL99V",
};

// Initialize a named app so it doesn't conflict with the primary "whub-server" app
const ordersApp = initializeApp(firebaseOrdersConfig, "OrdersApp");

// Firestore instance for the whubclasses project
export const dbOrders = getFirestore(ordersApp);
